import { Button } from "@datamole/wds-component-button";
import { Card } from "@datamole/wds-component-card";
import { faClose } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Popover, PopoverAnchor, PopoverContent, PopoverPortal } from "@radix-ui/react-popover";
import { useContext } from "react";

import { NavEdgeActions, NavEdgeCard, NavEdgeHeader } from "./entity-cards/nav-edge-card";
import { NavPointActions, NavPointCard, NavPointHeader } from "./entity-cards/nav-point-card";
import { PathCard } from "./entity-cards/path-card";
import { UtilityActions, UtilityCard, UtilityHeader } from "./entity-cards/utility-card";
import styles from "./info-popover.module.css";

import { EmployeeActions, EmployeeCard, EmployeeHeader } from "@/features/info-popover/entity-cards/employee-card";
import { EmptySeatActions, EmptySeatCard, EmptySeatHeader } from "@/features/info-popover/entity-cards/empty-seat-card";
import { RoomActions, RoomCard, RoomHeader } from "@/features/info-popover/entity-cards/room-card";
import { InfoPopoverContext } from "@/features/info-popover/popover.context";
import { useStorageSubscription } from "@/features/storage/use-storage-subscription";

export const InfoPopover = () => {
    const { trigger, setTrigger } = useContext(InfoPopoverContext);

    useStorageSubscription();

    const handleClosePopover = () => {
        setTrigger(null);
    };

    let triggerHeader = <div>Unknown Header</div>;
    let triggerCard = <div>Unknown Card</div>;
    let triggerActions = <></>;

    if (trigger?.type === "employee") {
        triggerHeader = <EmployeeHeader trigger={trigger} />;
        triggerCard = <EmployeeCard trigger={trigger} />;
        triggerActions = <EmployeeActions trigger={trigger} />;
    }

    if (trigger?.type === "room") {
        triggerHeader = <RoomHeader trigger={trigger} />;
        triggerCard = <RoomCard trigger={trigger} />;
        triggerActions = <RoomActions trigger={trigger} />;
    }

    if (trigger?.type === "empty-seat") {
        triggerHeader = <EmptySeatHeader />;
        triggerActions = <EmptySeatActions trigger={trigger} />;
        triggerCard = <EmptySeatCard trigger={trigger} />;
    }

    if (trigger?.type === "path") {
        triggerHeader = <b>Navigation</b>;
        triggerCard = <PathCard trigger={trigger} />;
    }

    if (trigger?.type === "nav-point") {
        triggerHeader = <NavPointHeader trigger={trigger} />;
        triggerCard = <NavPointCard trigger={trigger} />;
        triggerActions = <NavPointActions trigger={trigger} />;
    }

    if (trigger?.type === "nav-connect") {
        triggerHeader = <b>Connect Navigation Points</b>;
        triggerCard = <div style={{ padding: "8px 0" }}>Click another navigation point to create an edge.</div>;
    }

    if (trigger?.type === "nav-edge") {
        triggerHeader = <NavEdgeHeader trigger={trigger} />;
        triggerCard = <NavEdgeCard trigger={trigger} />;
        triggerActions = <NavEdgeActions trigger={trigger} />;
    }

    if (trigger?.type === "utility") {
        triggerHeader = <UtilityHeader trigger={trigger} />;
        triggerCard = <UtilityCard trigger={trigger} />;
        triggerActions = <UtilityActions trigger={trigger} />;
    }

    return (
        <Popover open={!!trigger}>
            <PopoverAnchor>
                <div className={styles.popover_anchor}></div>
            </PopoverAnchor>
            <PopoverPortal>
                <PopoverContent side="top" align="end" sideOffset={20} alignOffset={20}>
                    <Card>
                        <Card.Header>{triggerHeader}</Card.Header>
                        <Card.Content>{triggerCard}</Card.Content>
                        <Card.Footer>
                            {triggerActions}
                            <Button onClick={handleClosePopover}>
                                <Button.Icon>
                                    <FontAwesomeIcon icon={faClose} />
                                </Button.Icon>
                                <Button.Content>Close</Button.Content>
                            </Button>
                        </Card.Footer>
                    </Card>
                </PopoverContent>
            </PopoverPortal>
        </Popover>
    );
};
